var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#0075C9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9754 19C10.1858 19 8.62621 18.413 7.29651 17.2389C5.96681 16.0648 5.2013 14.5931 5 12.8235H6.26504C6.47377 14.2457 7.11611 15.4248 8.19205 16.3608C9.26801 17.2967 10.5291 17.7647 11.9754 17.7647C13.5869 17.7647 14.954 17.2054 16.0765 16.0868C17.1991 14.9681 17.7604 13.6059 17.7604 12C17.7604 10.3941 17.1991 9.03185 16.0765 7.91322C14.954 6.79459 13.5869 6.23528 11.9754 6.23528C11.0727 6.23528 10.2266 6.43509 9.43728 6.83471C8.64794 7.23432 7.96825 7.78413 7.39822 8.48414H9.55965V9.71941H5.36398V5.53845H6.60359V7.4896C7.27426 6.70092 8.07738 6.08881 9.01295 5.65329C9.94851 5.21776 10.936 5 11.9754 5C12.9501 5 13.8634 5.18372 14.7153 5.55115C15.5671 5.91857 16.3099 6.41796 16.9435 7.04932C17.5771 7.68069 18.0782 8.42081 18.4469 9.26968C18.8156 10.1186 19 11.0287 19 12C19 12.9713 18.8156 13.8814 18.4469 14.7303C18.0782 15.5792 17.5771 16.3193 16.9435 16.9507C16.3099 17.582 15.5671 18.0814 14.7153 18.4489C13.8634 18.8163 12.9501 19 11.9754 19ZM14.4563 15.3163L11.3794 12.2502V7.88234H12.619V11.7498L15.3272 14.4484L14.4563 15.3163Z",
    fill: "#0075C9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingIcon);
export default __webpack_public_path__ + "static/media/trackingIcon.d12080bc8f079d78668118dc424e8d5e.svg";
export { ForwardRef as ReactComponent };